// Seven-element system. See docs/05-combat-sim §5.7.1 (Layer C) and docs/15-open-questions §B.1.
// Affinity range pinned to 0.75-1.25 so auto-battle composition isn't a hard counter.
export const ELEMENTS = ['physical', 'fire', 'ice', 'lightning', 'earth', 'light', 'dark'];
/**
 * Damage multiplier when attacker's element strikes a defender's element.
 * Physical is neutral (1.0 against everything).
 * Magic pairs (fire⇔ice, lightning⇔earth, light⇔dark) have a 1.25/0.75 split.
 */
export const ELEMENT_AFFINITY = {
    physical: {
        physical: 1.0,
        fire: 1.0,
        ice: 1.0,
        lightning: 1.0,
        earth: 1.0,
        light: 1.0,
        dark: 1.0,
    },
    fire: { physical: 1.0, fire: 0.75, ice: 1.25, lightning: 1.0, earth: 1.0, light: 1.0, dark: 1.0 },
    ice: { physical: 1.0, fire: 1.25, ice: 0.75, lightning: 1.0, earth: 1.0, light: 1.0, dark: 1.0 },
    lightning: {
        physical: 1.0,
        fire: 1.0,
        ice: 1.0,
        lightning: 0.75,
        earth: 1.25,
        light: 1.0,
        dark: 1.0,
    },
    earth: {
        physical: 1.0,
        fire: 1.0,
        ice: 1.0,
        lightning: 1.25,
        earth: 0.75,
        light: 1.0,
        dark: 1.0,
    },
    light: {
        physical: 1.0,
        fire: 1.0,
        ice: 1.0,
        lightning: 1.0,
        earth: 1.0,
        light: 0.75,
        dark: 1.25,
    },
    dark: { physical: 1.0, fire: 1.0, ice: 1.0, lightning: 1.0, earth: 1.0, light: 1.25, dark: 0.75 },
};
export function affinityMultiplier(attacker, defender) {
    return ELEMENT_AFFINITY[attacker][defender];
}
//# sourceMappingURL=elements.js.map